import { Title, Container, Paragraph, Button, FixedBottom } from '@/components'
import styles from './PaymentResult.module.scss'
import getLinkHref from '@/helpers/getLinkHref'
import cn from 'classnames'
import Link from 'next/link'
import { NUMBER_CAR, supportPhone, supportPhoneLink } from '@/constants'
import { useRouter } from 'next/router'
import { PaymentReasonType } from '@/store/slices/stagesSlice/interfaces';
import { getCookie } from 'cookies-next'

export default function PaymentErrorPage({
  area,
  status,
  type,
}: {
  area: {
    id: string
    customising?: { button_back_color: string | null }
  } | null
  status: string,
  type: PaymentReasonType | null
}) {
  const carNumber = String(getCookie(NUMBER_CAR) || '')
  const router = useRouter()
  const hrefFindCar = getLinkHref({ type: 'find-car-number', data: { id: area?.id } })
  const hrefEvents = getLinkHref({ type: 'events', data: { areaId: area?.id } })
  const hrefSubscriptions = getLinkHref({ type: 'subscriptions', data: { areaId: area?.id } })
  const hrefMainPage = getLinkHref({ type: 'area', data: { id: area?.id } })
  const hrefFines = getLinkHref({ type: 'fines-page', data: { areaId: area?.id, number: carNumber } })

  const getRetryPageHref = () => {
    switch (type) {
      case 'ClientSubscription':
        return hrefSubscriptions
      case 'ClientEvent':
        return hrefEvents
      case 'Fine':
        return carNumber ? hrefFines : hrefMainPage
      default:
        return hrefFindCar
    }
  }
    
  const title =
    status === 'exhausted'
      ? 'Получить ответ от сервера не удалось. Попробуйте перезагрузить страницу или обратиться в поддержку'
      : 'Выполнить платеж не получилось. Пожалуйста, повторите попытку'

  return (
    <section className={cn(styles.section, styles.section__Error)}>
      <Container className={cn(styles.container, styles.container_isErrorPage)}>
        <div>
          <img
            className={styles.sign__Error__icon}
            src="/images/payment-failed.svg"
            alt="logo"
            width={87}
            height={87}
          />
          <Title align="center" className={styles.sign__Error__title}>
            {title}
          </Title>
          <Paragraph className={styles.sign__Error__descr}>Выполнить платеж не получилось</Paragraph>
        </div>

        <FixedBottom>
          {!!area ? (
            <div className={styles.buttons}>
              {status === 'exhausted' && (
                <Button
                  component="button"
                  className={styles.button}
                  onClick={() => {
                    router.reload()
                  }}
                >
                  Перезагрузить страницу
                </Button>
              )}
              <Link href={getRetryPageHref()} passHref>
                <Button
                  component="a"
                  className={styles.button}
                  background={area?.customising?.button_back_color}
                >
                  Повторить попытку оплаты
                </Button>
              </Link>
              <Button component="a" href={supportPhoneLink} className={styles.button} isTransparent>
                Обратиться в поддержку
              </Button>
            </div>
          ) : (
            <div className={styles.footerMessage}>
              Номер технической поддержки сервиса HippoParking:{' '}
              <a className={styles.footer__message_isDesktop} href={supportPhoneLink}>
                {supportPhone}
              </a>
            </div>
          )}
        </FixedBottom>
      </Container>
    </section>
  )
}
